module.exports = __webpack_public_path__ + "img/ic_etapes.eb374a27.svg";